{
  "app": {
    "name": "ショップ管理",
    "loading": "読み込み中…",
    "language": "言語",
    "skip_to_content": "本文へ移動"
  },
  "auth": {
    "sign_in_title": "ログイン",
    "sign_in_intro": "店舗スタッフ用の管理画面です。",
    "email": "メールアドレス",
    "password": "パスワード",
    "sign_in": "ログイン",
    "sign_out": "ログアウト",
    "signing_in": "ログイン中…",
    "not_available": "ログインはまだ接続されていません。スタッフアカウントは認証サービスと一緒に提供されます。",
    "invalid": "メールアドレスまたはパスワードが正しくありません。",
    "dev_bypass_hint": "開発モード：任意のメールアドレスとパスワードでログインできます。",
    "forbidden_title": "このページへのアクセス権がありません",
    "forbidden_body": "オーナーに権限の付与を依頼してください。"
  },
  "home": {
    "title": "今日は何をしますか？",
    "add_card": "カードを登録",
    "add_card_hint": "約2分で新しいカードを販売登録",
    "view_orders": "注文を見る",
    "view_orders_hint": "ウェブと店頭の注文をひとつの画面で",
    "ship": "発送する",
    "ship_hint": "梱包・追跡番号の入力・お客様への通知",
    "open_pos": "レジを開く",
    "open_pos_hint": "店頭POSでシフトを開始",
    "todo_empty": "今やることはありません。",
    "edit_banner": "トップページのバナーを変更",
    "edit_banner_hint": "トップページ上部の大きな画像を選んだ状態でエディタを開きます"
  },
  "nav": {
    "home": "ホーム",
    "orders": "注文",
    "products": "商品",
    "inventory": "在庫",
    "menu": "メニュー",
    "online_store": "ネットショップのデザイン",
    "content": "コンテンツ",
    "more": "メニュー",
    "main": "メインメニュー",
    "quick": "クイックメニュー",
    "section": "このメニュー内",
    "close_menu": "メニューを閉じる",
    "coming_soon": "準備中",
    "external": "（レジアプリが開きます）",
    "groups": {
      "home": "ホーム",
      "orders": "注文",
      "products": "商品",
      "inventory": "在庫",
      "customers": "お客様",
      "consignment": "委託販売",
      "pos": "レジ（POS）",
      "discounts": "割引コード",
      "content": "コンテンツ",
      "online_store": "ネットショップ",
      "settings": "設定"
    },
    "items": {
      "home": "ホーム",
      "orders_all": "すべての注文",
      "orders_bank_transfers": "確認待ちの銀行振込",
      "orders_drafts": "下書きの注文",
      "orders_pickups": "店頭受け取り",
      "orders_returns": "返品・返金",
      "orders_export_evidence": "輸出免税の証憑",
      "orders_documents": "書類をさがす（電帳法）",
      "products_all": "商品",
      "products_catalog": "カード図鑑",
      "products_collections": "コレクション",
      "products_categories": "カテゴリ",
      "products_brands": "ブランド",
      "products_attributes": "商品の追加項目",
      "products_import_export": "取り込み・書き出し",
      "inventory_stock": "在庫一覧",
      "inventory_movements": "在庫の履歴",
      "inventory_receipts": "入荷",
      "inventory_transfers": "移動",
      "inventory_counts": "棚卸し",
      "inventory_holds": "取り置き中のカード",
      "inventory_conflicts": "二重販売の判断",
      "inventory_live_shows": "ライブ配信",
      "inventory_locations": "店舗・倉庫",
      "customers_all": "お客様",
      "customers_groups": "グループ・タグ",
      "customers_store_credit": "ストアクレジット",
      "consignment_consignors": "委託者",
      "consignment_items": "委託中のカード",
      "consignment_settlements": "精算待ちの販売",
      "consignment_payouts": "委託者への支払い",
      "consignment_requests": "委託の申し込み",
      "consignment_kobutsu": "古物台帳",
      "pos_open": "レジを開く",
      "pos_registers": "レジ端末",
      "pos_shifts": "シフト・Zレポート",
      "pos_buylist": "買取",
      "pos_cash": "入出金",
      "discounts": "割引コード",
      "content_pages": "ページ",
      "content_policies": "ショップのルール・規約",
      "content_menus": "メニュー",
      "content_media": "画像・ファイル",
      "content_announcements": "お知らせ",
      "content_redirects": "古いウェブアドレス",
      "content_translations": "翻訳",
      "content_website_texts": "ウェブサイトの文言",
      "online_store_themes": "ネットショップのデザイン",
      "online_store_markets": "国・通貨",
      "online_store_languages": "ウェブサイトの言語",
      "online_store_seo": "検索エンジン（SEO）",
      "online_store_domains": "ウェブアドレス（ドメイン）",
      "settings_store": "ショップ情報",
      "settings_tax": "税金（消費税）",
      "settings_shipping": "配送",
      "settings_payments": "支払い",
      "settings_checkout": "購入手続き",
      "settings_notifications": "通知",
      "settings_inventory": "在庫のルール",
      "settings_pos": "レジのルール",
      "settings_staff": "スタッフ",
      "settings_roles": "役割とできること",
      "settings_api_keys": "他のアプリとの連携",
      "settings_audit": "変更履歴",
      "settings_jobs": "バックグラウンド処理・バックアップ",
      "settings_features": "今後の機能",
      "settings_website_refresh": "サイトの更新",
      "settings_channels": "マーケットプレイス（eBay・Whatnot など）",
      "settings_analytics": "レポート・分析",
      "help": "ヘルプ",
      "profile": "マイアカウント",
      "inbox": "やること・お知らせ"
    },
    "badge_conflicts_other": "確認が必要な問題 {{count}} 件",
    "badge_requests_other": "新しい委託の申し込み {{count}} 件"
  },
  "header": {
    "search": "検索",
    "search_hint": "なんでも検索（⌘K）",
    "inbox": "やること・お知らせ",
    "inbox_count": "やること・お知らせ：未対応 {{count}} 件",
    "inbox_critical": "緊急 {{count}} 件",
    "user_menu": "マイアカウントのメニュー",
    "profile": "マイアカウント",
    "help": "ヘルプ",
    "open_menu": "すべてのメニューを開く",
    "inbox_new_title": "新しいやること"
  },
  "page": {
    "help": "このページのヘルプ",
    "back": "戻る"
  },
  "states": {
    "loading": "読み込み中…",
    "error_title": "読み込めませんでした",
    "error_body": "接続を確認して、もう一度お試しください。",
    "retry": "もう一度",
    "empty_title": "まだ何もありません",
    "building_title": "この画面は準備中です",
    "building_body": "「{{title}}」は今後のアップデートで追加されます。ほかの機能はそのまま使えます。",
    "building_action": "ホームへ戻る",
    "coming_soon_title": "次のフェーズで追加されます",
    "coming_soon_body": "「{{title}}」は今はオフです。お店の準備ができたらオーナーがオンにします。"
  },
  "errors": {
    "not_found_title": "ページが見つかりません",
    "not_found_body": "このページはまだ存在しないか、移動しました。",
    "back_home": "ホームへ戻る",
    "boundary_title": "このページで問題が発生しました",
    "boundary_body": "ほかの画面は問題ありません。もう一度試すか、ホームに戻ってください。",
    "try_again": "もう一度",
    "reference": "参照コード：{{id}}",
    "copy_reference": "参照コードをコピー",
    "copied": "コピーしました",
    "problem_how_to_fix": "問題あり — タップして直し方を見る",
    "how_to_fix": "次にすること"
  },
  "money": {
    "tax_included": "税込",
    "tax_excluded": "税抜 {{amount}}"
  },
  "date": {
    "jst": "JST"
  },
  "rank": {
    "A": "美品",
    "B": "軽い傷",
    "C": "傷あり",
    "D": "ダメージ",
    "damaged": "ダメージ大",
    "scale": "A 美品 · B 軽い傷 · C 傷あり · D ダメージ",
    "badge_label": "ランク{{rank}} — {{label}}",
    "select_label": "カードの状態（ランク）",
    "select_hint": "カードに合う文字を選んでください。お客様にも必ず表示されます。",
    "damaged_label": "大きなダメージあり（折れ・破れ・水濡れ跡）",
    "ebay_preview": "eBayではこう表示されます：{{condition}}",
    "ebay_note": "将来eBayに出品するときだけ使います。",
    "ebay": {
      "A": "Near Mint or Better",
      "B": "Lightly Played",
      "C": "Moderately Played",
      "D": "Heavily Played",
      "D_damaged": "Damaged"
    }
  },
  "status": {
    "active": "販売中",
    "draft": "下書き",
    "problem": "問題あり",
    "pending": "待ち",
    "archived": "アーカイブ",
    "info": "お知らせ"
  },
  "toast": {
    "region": "メッセージ",
    "undo": "元に戻す",
    "undo_seconds": "元に戻す（{{seconds}} 秒）",
    "undone": "元に戻しました",
    "undo_failed": "元に戻せませんでした",
    "dismiss": "メッセージを閉じる",
    "more": "ほか {{count}} 件のメッセージ"
  },
  "confirm": {
    "cancel": "キャンセル",
    "confirm": "確定",
    "what_happens": "こうなります",
    "reason_label": "理由（履歴に残ります）",
    "reason_placeholder": "例：店内で破損、数え直し",
    "reason_required": "短い理由を入力してください"
  },
  "offline": {
    "banner": "インターネットに接続されていません — 入力した内容は残り、接続が戻ると保存されます。",
    "back_online": "接続が戻りました"
  },
  "forms": {
    "required": "必須",
    "optional": "任意",
    "saving": "保存中…",
    "save": "保存",
    "draft_saved_at": "下書きを保存しました {{time}}",
    "restore_title": "下書きを復元しますか？",
    "restore_body": "{{time}} に入力を始めて、まだ保存していません。",
    "restore": "下書きを復元",
    "discard": "最初からやり直す",
    "leave_title": "保存せずに移動しますか？",
    "leave_body": "このページの入力内容はまだ保存されていません。下書きはこの端末に残ります。",
    "leave": "ページを移動",
    "stay": "このページに残る",
    "conflict_title": "あなたより先に変更した人がいます",
    "conflict_body": "{{name}} が新しい内容を保存しました。最新を読み込んで変更を確認するか、自分の内容で上書き保存してください。",
    "conflict_someone": "ほかのスタッフ",
    "load_latest": "最新を読み込む",
    "overwrite": "自分の内容で保存",
    "fix_errors": "赤く表示された {{count}} 件を直してください。",
    "help": "これは何？",
    "help_more": "くわしく読む",
    "select_placeholder": "選んでください…",
    "select_search": "入力して検索",
    "select_empty": "該当なし",
    "on": "オン",
    "off": "オフ",
    "yen_hint": "円・税込（整数）",
    "date_hint": "日本時間（JST）"
  },
  "table": {
    "rows_per_page": "1ページの行数",
    "next": "次へ",
    "previous": "前へ",
    "page_rows": "{{count, number}} 件を表示中",
    "total": "全 {{count, number}} 件",
    "filters": "絞り込み",
    "open_filters": "絞り込み（{{count}}）",
    "clear_filters": "すべてクリア",
    "remove_filter": "絞り込み「{{name}}」を外す",
    "apply": "結果を表示",
    "any": "すべて",
    "yes": "はい",
    "no": "いいえ",
    "search": "検索",
    "from": "から",
    "to": "まで",
    "today": "今日",
    "last_7_days": "過去7日",
    "this_month": "今月",
    "saved_views": "保存した表示",
    "all_rows": "すべて",
    "save_view": "この表示を保存",
    "view_name": "表示の名前",
    "rename_view": "名前を変更",
    "delete_view": "削除",
    "delete_view_title": "表示「{{name}}」を削除しますか？",
    "delete_view_body": "保存した絞り込みだけが消えます。データは削除されません。",
    "pin_view": "上に固定",
    "unpin_view": "固定を外す",
    "view_saved": "表示「{{name}}」を保存しました",
    "view_deleted": "表示を削除しました",
    "columns": "表示する列",
    "show_column": "{{name}} を表示",
    "move_up": "{{name}} を上へ",
    "move_down": "{{name}} を下へ",
    "pin_left": "{{name}} を左に固定",
    "density": "行の高さ",
    "density_comfortable": "ゆったり",
    "density_compact": "コンパクト",
    "export_csv": "CSVをダウンロード",
    "exporting": "ファイルを準備中…",
    "exported": "CSVをダウンロードしました",
    "selected_count": "{{count, number}} 件を選択中",
    "clear_selection": "選択を解除",
    "select_all": "このページをすべて選択",
    "select_row": "行を選択",
    "sort_by": "{{name}} で並べ替え",
    "loading": "読み込み中…",
    "empty": "該当する行がありません。絞り込みを変えてみてください。",
    "error": "一覧を読み込めませんでした。",
    "actions": "操作",
    "yen_column": "{{name}}（円）",
    "load_more": "もっと見る"
  },
  "roles": {
    "owner": "オーナー",
    "manager": "店長",
    "staff": "スタッフ",
    "cashier": "レジ担当",
    "content_editor": "ウェブ編集担当",
    "consignment_manager": "委託担当"
  },
  "permissions": {
    "needs_owner": "オーナーだけが操作できます",
    "needs_manager": "店長の権限が必要です（店長かオーナーに依頼してください）",
    "needs_other": "このアカウントでは操作できません。オーナーに権限を依頼してください"
  },
  "flags": {
    "when": "オーナーの判断後に使えるようになります",
    "page_intro": "この機能は今は使えません。ほかの管理画面は通常どおり使えます。",
    "payments_stripe": {
      "title": "オンラインカード決済（Stripe）",
      "body": "ウェブでカード・Apple Pay・Google Pay で支払えるようになります。"
    },
    "payments_stripe_connect": {
      "title": "Stripe で委託者に支払う",
      "body": "委託者への支払いが Stripe から直接口座に届きます。"
    },
    "channels_ebay": {
      "title": "eBay で販売",
      "body": "カードが自動で eBay に出品され、どこかで売れたら全部から取り下げます。"
    },
    "channels_whatnot": {
      "title": "Whatnot のライブで販売",
      "body": "ライブオークションでカードを紹介し、売れたカードは注文として戻ります。"
    },
    "channels_mercari": {
      "title": "メルカリShops で販売",
      "body": "同じ在庫からメルカリShopsに出せます。"
    },
    "channels_tiktok_shop": {
      "title": "TikTok Shop で販売",
      "body": "同じ在庫から TikTok Shop に出せます。"
    },
    "tax_nta_api": {
      "title": "免税の記録を自動で国税庁へ送信",
      "body": "ファイルをアップロードせずに購入記録情報を送れます。"
    },
    "shipping_shipandco": {
      "title": "Ship&co で送り状を作成",
      "body": "運送会社の送り状と追跡番号を一度に作れます。"
    },
    "shipping_zonos": {
      "title": "関税を注文時に支払い（Zonos）",
      "body": "海外のお客様が注文時に関税を支払えます。"
    }
  },
  "order_status": {
    "pending_payment": "支払い待ち",
    "paid": "支払い済み",
    "partially_paid": "一部支払い",
    "partially_refunded": "一部返金",
    "refunded": "返金済み",
    "cancelled": "キャンセル"
  },
  "fulfillment_status": {
    "unfulfilled": "未準備",
    "preparing": "準備中",
    "ready": "準備完了",
    "shipped": "発送済み",
    "in_transit": "配送中",
    "delivered": "お届け済み",
    "partial": "一部発送",
    "pickup_ready": "店頭受取準備完了",
    "picked_up": "受取済み",
    "return_requested": "返品申請",
    "return_received": "返品受領"
  },
  "sortable": {
    "drag": "{{name}} をドラッグ",
    "up": "{{name}} を上へ",
    "down": "{{name}} を下へ",
    "moved": "{{name}} は {{count}} 件中 {{to}} 番目になりました"
  },
  "dialog": {
    "close": "閉じる",
    "cancel": "キャンセル"
  },
  "copy": {
    "copy": "コピー",
    "copied": "コピーしました",
    "failed": "選択して手動でコピー"
  },
  "live": {
    "menu": "自動更新",
    "menu_hint": "変更があると、この画面は自動で新しくなります。",
    "toasts": "新しいことがあったらお知らせを表示",
    "sound": "小さな音も鳴らす",
    "new_order": "新しい注文が入りました",
    "transfer_notice": "お客様から「銀行振込で支払った」と連絡がありました",
    "payment_received": "注文の入金がありました",
    "pos_sale": "店頭で販売がありました",
    "oversell": "同じカードが二重に売れました。すぐに確認してください。",
    "consignment_request": "委託の新しい申し込みがあります",
    "see": "一覧で見る",
    "new_row": "新着",
    "conflict": "編集中に他の人がこの内容を変更しました。",
    "conflict_by": "編集中に{{name}}さんがこの内容を変更しました。",
    "reload": "最新を読み込む"
  },
  "shop_switches": {
    "licence_missing": "古物商許可番号がまだ保存されていないため、買取と委託受付は停止中です。",
    "licence_fix": "ショップ情報で入力する",
    "web_orders_paused": "現在、サイトの注文受付を一時停止しています。店頭レジは通常どおり使えます。",
    "web_orders_open": "購入手続きの設定を開く"
  }
}
